module.exports = __webpack_public_path__ + "static/media/myneflix2.d09a0a9e.gif";